module.exports = __webpack_public_path__ + "static/media/icon_api.fc861cf6.png";